
import {getUserById} from '../api/getUserById';
import {setGetUserAction} from '../action';

const setGetUserById = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUserById(params);
            
            if (data.status === 'success') {
                dispatch(setGetUserAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetUserById
}